var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 915,
    height: 645,
    viewBox: "0 0 915 645",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_528_48652)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_528_48652)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 3.1303 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 3.1303 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 3.1303 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 3.1303 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 3.1303 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 3.1303 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 3.1303 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 3.1303 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 20.6498 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 20.6498 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 20.6498 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 20.6498 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 20.6498 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 20.6498 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 20.6498 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 20.6498 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 38.1694 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 36.5651,
    r: 3.12751,
    transform: "rotate(90 38.1694 36.5651)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 69.0909,
    r: 3.12751,
    transform: "rotate(90 38.1694 69.0909)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 38.1694 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 20.3045,
    r: 3.12751,
    transform: "rotate(90 38.1694 20.3045)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 52.8303,
    r: 3.12751,
    transform: "rotate(90 38.1694 52.8303)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 85.3538,
    r: 3.12751,
    transform: "rotate(90 38.1694 85.3538)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 38.1694 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 55.6889 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 55.6889 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 55.6889 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 55.6889 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 55.6889 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 55.6889 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 55.6889 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 55.6889 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 73.1928 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 73.1928 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 73.1928 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 73.1928 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 73.1928 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 73.1928 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 73.1928 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 73.1928 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 90.6967 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 90.6967 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 90.6967 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 90.6967 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 90.6967 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 90.6967 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 90.6967 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 90.6967 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 108.232 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 108.232 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 108.232 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 108.232 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 108.232 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 108.232 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 108.232 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 108.232 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 125.732 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 125.732 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 125.732 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 125.732 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 125.732 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 125.732 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 125.732 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 125.732 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 141.9 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 141.9 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 141.9 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 141.9 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 141.9 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 141.9 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 141.9 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 141.9 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 159.419 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 159.419 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 159.419 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 159.419 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 159.419 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 159.419 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 159.419 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 159.419 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 176.939 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 176.939 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 176.939 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 176.939 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 176.939 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 176.939 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 176.939 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 176.939 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 194.455 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 194.455 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 194.455 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 194.455 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 194.455 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 194.455 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 194.455 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 194.455 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 211.958 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 211.958 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 211.958 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 211.958 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 211.958 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 211.958 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 211.958 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 211.958 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 229.474 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 229.474 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 229.474 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 229.474 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 229.474 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 229.474 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 229.474 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 229.474 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 247.001 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 247.001 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 247.001 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 247.001 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 247.001 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 247.001 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 247.001 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 247.001 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 264.501 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 264.501 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 264.501 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 264.501 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 264.501 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 264.501 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 264.501 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 264.501 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 280.677 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 280.677 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 280.677 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 280.677 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 280.677 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 280.677 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 280.677 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 280.677 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 298.197 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 298.197 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 298.197 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 298.197 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 298.197 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 298.197 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 298.197 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 298.197 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 315.716 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 315.716 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 315.716 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 315.716 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 315.716 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 315.716 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 315.716 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 315.716 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 333.232 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 333.232 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 333.232 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 333.232 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 333.232 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 333.232 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 333.232 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 333.232 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 350.736 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 350.736 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 350.736 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 350.736 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 350.736 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 350.736 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 350.736 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 350.736 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 368.247 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 368.247 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 368.247 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 368.247 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 368.247 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 368.247 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 368.247 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 368.247 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 385.779 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 36.5651,
    r: 3.12751,
    transform: "rotate(90 385.779 36.5651)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 69.0909,
    r: 3.12751,
    transform: "rotate(90 385.779 69.0909)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 385.779 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 20.3045,
    r: 3.12751,
    transform: "rotate(90 385.779 20.3045)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 52.8303,
    r: 3.12751,
    transform: "rotate(90 385.779 52.8303)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 85.3538,
    r: 3.12751,
    transform: "rotate(90 385.779 85.3538)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 385.779 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 403.287 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 403.287 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 403.287 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 403.287 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 403.287 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 403.287 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 403.287 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 403.287 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 419.462 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 419.462 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 419.462 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 419.462 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 419.462 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 419.462 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 419.462 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 419.462 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 436.978 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 436.978 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 436.978 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 436.978 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 436.978 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 436.978 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 436.978 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 436.978 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 454.505 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 454.505 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 454.505 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 454.505 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 454.505 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 454.505 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 454.505 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 454.505 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 472.013 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 472.013 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 472.013 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 472.013 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 472.013 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 472.013 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 472.013 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 472.013 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 489.517 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 489.517 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 489.517 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 489.517 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 489.517 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 489.517 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 489.517 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 489.517 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 507.029 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 507.029 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 507.029 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 507.029 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 507.029 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 507.029 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 507.029 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 507.029 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 524.556 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 524.556 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 524.556 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 524.556 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 524.556 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 524.556 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 524.556 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 524.556 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 542.064 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 542.064 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 542.064 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 542.064 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 542.064 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 542.064 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 542.064 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 542.064 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 558.244 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 558.244 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 558.244 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 558.244 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 558.244 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 558.244 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 558.244 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 558.244 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 575.763 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 575.763 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 575.763 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 575.763 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 575.763 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 575.763 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 575.763 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 575.763 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 593.283 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 593.283 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 593.283 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 593.283 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 593.283 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 593.283 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 593.283 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 593.283 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 610.794 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 610.794 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 610.794 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 610.794 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 610.794 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 610.794 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 610.794 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 610.794 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 628.298 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 628.298 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 628.298 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 628.298 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 628.298 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 628.298 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 628.298 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 628.298 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 645.81 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 645.81 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 645.81 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 645.81 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 645.81 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 645.81 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 645.81 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 645.81 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 663.337 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 663.337 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 663.337 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 663.337 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 663.337 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 663.337 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 663.337 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 663.337 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 680.845 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 680.845 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 680.845 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 680.845 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 680.845 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 680.845 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 680.845 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 680.845 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 697.013 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 697.013 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 697.013 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 697.013 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 697.013 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 697.013 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 697.013 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 697.013 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 714.533 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 714.533 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 714.533 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 714.533 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 714.533 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 714.533 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 714.533 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 714.533 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 732.052 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 36.5651,
    r: 3.12751,
    transform: "rotate(90 732.052 36.5651)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 69.0909,
    r: 3.12751,
    transform: "rotate(90 732.052 69.0909)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 732.052 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 20.3045,
    r: 3.12751,
    transform: "rotate(90 732.052 20.3045)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 52.8303,
    r: 3.12751,
    transform: "rotate(90 732.052 52.8303)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 85.3538,
    r: 3.12751,
    transform: "rotate(90 732.052 85.3538)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 732.052 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 749.572 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 749.572 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 749.572 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 749.572 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 749.572 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 749.572 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 749.572 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 749.572 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 767.076 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 767.076 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 767.076 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 767.076 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 767.076 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 767.076 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 767.076 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 767.076 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 784.58 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 784.58 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 784.58 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 784.58 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 784.58 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 784.58 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 784.58 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 784.58 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 802.115 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 802.115 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 802.115 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 802.115 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 802.115 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 802.115 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 802.115 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 802.115 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 4.03923,
    r: 3.12751,
    transform: "rotate(90 819.615 4.03923)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 819.615 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 819.615 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 819.615 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 819.615 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 819.615 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 819.615 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 819.615 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 835.783 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 835.783 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 835.783 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 835.783 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 835.783 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 835.783 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 835.783 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 835.783 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 853.302 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 853.302 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 853.302 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 853.302 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 853.302 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 853.302 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 853.302 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 853.302 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 870.822 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 870.822 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 870.822 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 870.822 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 870.822 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 870.822 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 870.822 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 870.822 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 888.337 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 888.337 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 888.337 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 888.337 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 888.337 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 888.337 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 888.337 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 888.337 117.88)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 4.03922,
    r: 3.12751,
    transform: "rotate(90 905.841 4.03922)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 36.565,
    r: 3.12751,
    transform: "rotate(90 905.841 36.565)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 69.0908,
    r: 3.12751,
    transform: "rotate(90 905.841 69.0908)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 101.619,
    r: 3.12751,
    transform: "rotate(90 905.841 101.619)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 20.3044,
    r: 3.12751,
    transform: "rotate(90 905.841 20.3044)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 52.8302,
    r: 3.12751,
    transform: "rotate(90 905.841 52.8302)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 85.3537,
    r: 3.12751,
    transform: "rotate(90 905.841 85.3537)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 117.88,
    r: 3.12751,
    transform: "rotate(90 905.841 117.88)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 3.1303 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 3.1303 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 3.1303 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 3.1303 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 3.1303 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 3.1303 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 3.1303 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 3.1303 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 20.6498 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 20.6498 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 20.6498 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 20.6498 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 20.6498 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 20.6498 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 20.6498 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 20.6498 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 38.1694 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 38.1694 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 38.1694 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 38.1694 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 38.1694 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 38.1694 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 38.1694 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 38.1694 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 55.6889 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 55.6889 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 55.6889 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 55.6889 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 55.6889 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 55.6889 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 55.6889 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 55.6889 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 73.1928 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 73.1928 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 73.1928 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 73.1928 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 73.1928 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 73.1928 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 73.1928 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 73.1928 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 90.6967 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 90.6967 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 90.6967 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 90.6967 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 90.6967 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 90.6967 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 90.6967 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 90.6967 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 108.232 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 108.232 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 108.232 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 108.232 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 108.232 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 108.232 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 108.232 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 108.232 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 125.732 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 125.732 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 125.732 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 125.732 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 151.075,
    r: 3.12751,
    transform: "rotate(90 125.732 151.075)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 125.732 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 125.732 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 125.732 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 141.9 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 141.9 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 141.9 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 141.9 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 141.9 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 141.9 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 141.9 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 141.9 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 159.419 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 159.419 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 159.419 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 159.419 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 159.419 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 159.419 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 159.419 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 159.419 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 176.939 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 176.939 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 176.939 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 176.939 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 176.939 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 176.939 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 176.939 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 176.939 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 194.455 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 194.455 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 194.455 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 194.455 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 194.455 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 194.455 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 194.455 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 194.455 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 211.958 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 211.958 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 211.958 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 211.958 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 211.958 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 211.958 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 211.958 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 211.958 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 229.474 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 229.474 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 229.474 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 229.474 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 229.474 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 229.474 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 229.474 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 229.474 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 247.001 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 247.001 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 247.001 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 247.001 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 247.001 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 247.001 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 247.001 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 247.001 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 264.501 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 264.501 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 264.501 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 264.501 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 264.501 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 264.501 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 264.501 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 264.501 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 280.677 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 280.677 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 280.677 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 280.677 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 280.677 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 280.677 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 280.677 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 280.677 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 298.197 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 298.197 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 298.197 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 298.197 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 298.197 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 298.197 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 298.197 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 298.197 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 315.716 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 315.716 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 315.716 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 315.716 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 315.716 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 315.716 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 315.716 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 315.716 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 333.232 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 333.232 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 333.232 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 333.232 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 333.232 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 333.232 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 333.232 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 333.232 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 350.736 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 350.736 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 350.736 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 350.736 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 350.736 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 350.736 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 350.736 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 350.736 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 368.247 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 368.247 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 368.247 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 368.247 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 368.247 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 368.247 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 368.247 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 368.247 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 385.779 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 385.779 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 385.779 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 385.779 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 385.779 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 385.779 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 385.779 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 385.779 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 403.287 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 403.287 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 403.287 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 403.287 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 403.287 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 403.287 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 403.287 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 403.287 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 419.462 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 419.462 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 419.462 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 419.462 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 419.462 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 419.462 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 419.462 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 419.462 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 436.978 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 436.978 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 436.978 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 436.978 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 436.978 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 436.978 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 436.978 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 436.978 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 454.505 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 454.505 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 454.505 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 454.505 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 454.505 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 454.505 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 454.505 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 454.505 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 472.013 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 472.013 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 472.013 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 472.013 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 472.013 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 472.013 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 472.013 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 472.013 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 489.517 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 489.517 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 489.517 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 489.517 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 489.517 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 489.517 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 489.517 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 489.517 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 507.029 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 507.029 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 507.029 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 507.029 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 507.029 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 507.029 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 507.029 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 507.029 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 524.556 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 524.556 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 524.556 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 524.556 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 524.556 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 524.556 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 524.556 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 524.556 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 542.064 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 542.064 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 542.064 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 542.064 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 542.064 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 542.064 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 542.064 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 542.064 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 558.244 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 558.244 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 558.244 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 558.244 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 558.244 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 558.244 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 558.244 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 558.244 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 575.763 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 575.763 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 575.763 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 575.763 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 575.763 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 575.763 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 575.763 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 575.763 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 593.283 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 593.283 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 593.283 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 593.283 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 593.283 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 593.283 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 593.283 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 593.283 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 610.794 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 610.794 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 610.794 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 610.794 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 610.794 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 610.794 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 610.794 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 610.794 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 628.298 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 628.298 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 628.298 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 628.298 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 628.298 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 628.298 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 628.298 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 628.298 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 645.81 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 645.81 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 645.81 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 645.81 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 645.81 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 645.81 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 645.81 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 645.81 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 663.337 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 663.337 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 663.337 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 663.337 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 663.337 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 663.337 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 663.337 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 663.337 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 680.845 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 680.845 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 680.845 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 680.845 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 680.845 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 680.845 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 680.845 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 680.845 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 697.013 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 697.013 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 697.013 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 697.013 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 697.013 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 697.013 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 697.013 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 697.013 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 714.533 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 714.533 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 714.533 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 714.533 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 714.533 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 714.533 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 714.533 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 714.533 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 732.052 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 732.052 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 732.052 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 732.052 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 732.052 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 732.052 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 732.052 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 732.052 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 749.572 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 749.572 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 749.572 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 749.572 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 749.572 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 749.572 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 749.572 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 749.572 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 767.076 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 767.076 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 767.076 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 767.076 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 767.076 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 767.076 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 767.076 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 767.076 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 784.58 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 784.58 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 784.58 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 784.58 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 784.58 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 784.58 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 784.58 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 784.58 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 802.115 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 802.115 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 802.115 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 802.115 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 802.115 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 802.115 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 802.115 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 802.115 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 819.615 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 819.615 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 819.615 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 819.615 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 819.615 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 819.615 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 819.615 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 819.615 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 835.783 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 835.783 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 835.783 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 835.783 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 835.783 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 835.783 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 835.783 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 835.783 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 853.302 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 853.302 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 853.302 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 853.302 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 853.302 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 853.302 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 853.302 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 853.302 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 870.822 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 870.822 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 870.822 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 870.822 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 870.822 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 870.822 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 870.822 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 870.822 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 888.337 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 888.337 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 888.337 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 888.337 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 888.337 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 888.337 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 888.337 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 888.337 248.65)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 134.809,
    r: 3.12751,
    transform: "rotate(90 905.841 134.809)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 167.335,
    r: 3.12751,
    transform: "rotate(90 905.841 167.335)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 199.861,
    r: 3.12751,
    transform: "rotate(90 905.841 199.861)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 232.389,
    r: 3.12751,
    transform: "rotate(90 905.841 232.389)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 151.074,
    r: 3.12751,
    transform: "rotate(90 905.841 151.074)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 183.6,
    r: 3.12751,
    transform: "rotate(90 905.841 183.6)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 216.124,
    r: 3.12751,
    transform: "rotate(90 905.841 216.124)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 248.65,
    r: 3.12751,
    transform: "rotate(90 905.841 248.65)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 3.1303 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 3.1303 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 3.1303 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 3.1303 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 3.1303 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 3.1303 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 3.1303 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 3.1303 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 20.6498 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 20.6498 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 20.6498 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 20.6498 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 20.6498 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 20.6498 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 20.6498 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 20.6498 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 38.1694 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 38.1694 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 38.1694 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 38.1694 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 38.1694 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 38.1694 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 38.1694 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 38.1694 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 55.6889 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 55.6889 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 55.6889 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 55.6889 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 55.6889 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 55.6889 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 55.6889 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 55.6889 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 73.1928 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 73.1928 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 73.1928 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 73.1928 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 73.1928 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 73.1928 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 73.1928 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 73.1928 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 90.6967 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 90.6967 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 90.6967 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 90.6967 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 90.6967 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 90.6967 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 90.6967 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 90.6967 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 108.232 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 108.232 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 108.232 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 108.232 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 108.232 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 108.232 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 108.232 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 108.232 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 125.732 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 125.732 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 125.732 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 125.732 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 125.732 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 125.732 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 125.732 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 125.732 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 141.9 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 141.9 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 141.9 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 141.9 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 141.9 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 141.9 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 141.9 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 141.9 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 159.419 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 159.419 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 159.419 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 159.419 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 159.419 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 159.419 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 159.419 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 159.419 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 176.939 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 176.939 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 176.939 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 176.939 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 176.939 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 176.939 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 176.939 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 176.939 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 194.455 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 194.455 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 194.455 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 194.455 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 194.455 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 194.455 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 194.455 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 194.455 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 211.958 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 211.958 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 211.958 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 211.958 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 211.958 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 211.958 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 211.958 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 211.958 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 229.474 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 229.474 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 229.474 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 229.474 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 229.474 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 229.474 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 229.474 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 229.474 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 247.001 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 247.001 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 247.001 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 247.001 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 247.001 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 247.001 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 247.001 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 247.001 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 264.501 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 264.501 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 264.501 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 264.501 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 264.501 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 264.501 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 264.501 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 264.501 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 280.677 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 280.677 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 280.677 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 280.677 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 280.677 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 280.677 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 280.677 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 280.677 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 298.197 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 298.197 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 298.197 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 298.197 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 298.197 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 298.197 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 298.197 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 298.197 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 315.716 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 315.716 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 315.716 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 315.716 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 315.716 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 315.716 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 315.716 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 315.716 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 333.232 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 333.232 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 333.232 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 333.232 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 333.232 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 333.232 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 333.232 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 333.232 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 350.736 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 350.736 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 350.736 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 350.736 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 350.736 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 350.736 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 350.736 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 350.736 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 368.247 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 368.247 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 368.247 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 368.247 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 368.247 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 368.247 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 368.247 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 368.247 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 385.779 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 385.779 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 385.779 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 385.779 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 385.779 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 385.779 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 385.779 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 385.779 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 403.287 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 403.287 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 403.287 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 403.287 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 403.287 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 403.287 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 403.287 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 403.287 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 419.462 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 419.462 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 419.462 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 419.462 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 419.462 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 419.462 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 419.462 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 419.462 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 436.978 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 436.978 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 436.978 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 436.978 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 436.978 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 436.978 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 436.978 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 436.978 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 454.505 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 454.505 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 454.505 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 454.505 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 454.505 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 454.505 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 454.505 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 454.505 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 472.013 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 472.013 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 472.013 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 472.013 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 472.013 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 472.013 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 472.013 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 472.013 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 489.517 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 489.517 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 489.517 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 489.517 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 489.517 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 489.517 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 489.517 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 489.517 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 507.029 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 507.029 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 507.029 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 507.029 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 507.029 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 507.029 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 507.029 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 507.029 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 524.556 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 524.556 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 524.556 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 524.556 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 524.556 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 524.556 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 524.556 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 524.556 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 542.064 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 542.064 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 542.064 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 542.064 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 542.064 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 542.064 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 542.064 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 542.064 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 558.244 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 558.244 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 558.244 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 558.244 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 558.244 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 558.244 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 558.244 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 558.244 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 575.763 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 575.763 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 575.763 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 575.763 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 575.763 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 575.763 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 575.763 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 575.763 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 593.283 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 593.283 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 593.283 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 593.283 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 593.283 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 593.283 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 593.283 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 593.283 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 610.794 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 610.794 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 610.794 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 610.794 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 610.794 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 610.794 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 610.794 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 610.794 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 628.298 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 628.298 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 628.298 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 628.298 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 628.298 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 628.298 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 628.298 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 628.298 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 645.81 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 645.81 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 645.81 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 645.81 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 645.81 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 645.81 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 645.81 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 645.81 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 663.337 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 663.337 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 663.337 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 663.337 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 663.337 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 663.337 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 663.337 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 663.337 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 680.845 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 680.845 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 680.845 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 680.845 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 680.845 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 680.845 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 680.845 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 680.845 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 697.013 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 697.013 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 697.013 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 697.013 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 697.013 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 697.013 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 697.013 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 697.013 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 714.533 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 714.533 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 714.533 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 714.533 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 714.533 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 714.533 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 714.533 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 714.533 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 732.052 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 732.052 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 732.052 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 732.052 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 732.052 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 732.052 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 732.052 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 732.052 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 749.572 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 749.572 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 749.572 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 749.572 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 749.572 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 749.572 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 749.572 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 749.572 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 767.076 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 767.076 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 767.076 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 767.076 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 767.076 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 767.076 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 767.076 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 767.076 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 784.58 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 784.58 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 784.58 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 784.58 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 784.58 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 784.58 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 784.58 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 784.58 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 802.115 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 802.115 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 802.115 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 802.115 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 802.115 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 802.115 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 802.115 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 802.115 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 819.615 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 819.615 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 819.615 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 819.615 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 819.615 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 819.615 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 819.615 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 819.615 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 835.783 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 835.783 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 835.783 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 835.783 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 835.783 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 835.783 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 835.783 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 835.783 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 853.302 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 853.302 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 853.302 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 853.302 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 853.302 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 853.302 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 853.302 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 853.302 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 870.822 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 870.822 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 870.822 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 870.822 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 870.822 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 870.822 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 870.822 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 870.822 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 888.337 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 888.337 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 888.337 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 888.337 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 888.337 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 888.337 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 888.337 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 888.337 379.42)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 265.58,
    r: 3.12751,
    transform: "rotate(90 905.841 265.58)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 298.105,
    r: 3.12751,
    transform: "rotate(90 905.841 298.105)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 330.631,
    r: 3.12751,
    transform: "rotate(90 905.841 330.631)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 363.159,
    r: 3.12751,
    transform: "rotate(90 905.841 363.159)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 281.845,
    r: 3.12751,
    transform: "rotate(90 905.841 281.845)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 314.371,
    r: 3.12751,
    transform: "rotate(90 905.841 314.371)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 346.894,
    r: 3.12751,
    transform: "rotate(90 905.841 346.894)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 379.42,
    r: 3.12751,
    transform: "rotate(90 905.841 379.42)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 3.1303 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 3.1303 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 3.1303 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 3.1303 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 3.1303 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 3.1303 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 3.1303 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 3.1303 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 20.6498 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 20.6498 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 20.6498 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 20.6498 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 20.6498 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 20.6498 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 20.6498 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 20.6498 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 38.1694 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 38.1694 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 38.1694 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 38.1694 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 38.1694 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 38.1694 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 38.1694 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 38.1694 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 55.6889 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 55.6889 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 55.6889 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 55.6889 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 55.6889 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 55.6889 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 55.6889 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 55.6889 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 73.1928 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 73.1928 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 73.1928 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 73.1928 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 73.1928 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 73.1928 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 73.1928 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 73.1928 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 90.6967 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 90.6967 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 90.6967 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 90.6967 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 90.6967 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 90.6967 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 90.6967 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 90.6967 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 108.232 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 108.232 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 108.232 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 108.232 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 108.232 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 108.232 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 108.232 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 108.232 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 125.732 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 125.732 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 125.732 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 125.732 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 125.732 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 125.732 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 125.732 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 125.732 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 141.9 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 141.9 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 141.9 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 141.9 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 141.9 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 141.9 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 141.9 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 141.9 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 159.419 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 159.419 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 159.419 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 159.419 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 159.419 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 159.419 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 159.419 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 159.419 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 176.939 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 176.939 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 176.939 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 176.939 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 176.939 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 176.939 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 176.939 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 176.939 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 194.455 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 194.455 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 194.455 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 194.455 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 194.455 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 194.455 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 194.455 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 194.455 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 211.958 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 211.958 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 211.958 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 211.958 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 211.958 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 211.958 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 211.958 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 211.958 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 229.474 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 229.474 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 229.474 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 229.474 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 229.474 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 229.474 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 229.474 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 229.474 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 247.001 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 247.001 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 247.001 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 247.001 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 247.001 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 247.001 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 247.001 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 247.001 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 264.501 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 264.501 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 264.501 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 264.501 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 264.501 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 264.501 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 264.501 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 264.501 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 280.677 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 280.677 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 280.677 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 280.677 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 280.677 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 280.677 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 280.677 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 280.677 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 298.197 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 298.197 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 298.197 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 298.197 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 298.197 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 298.197 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 298.197 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 298.197 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 315.716 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 315.716 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 315.716 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 315.716 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 315.716 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 315.716 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 315.716 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 315.716 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 333.232 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 333.232 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 333.232 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 333.232 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 333.232 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 333.232 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 333.232 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 333.232 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 350.736 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 350.736 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 350.736 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 350.736 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 350.736 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 350.736 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 350.736 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 350.736 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 368.247 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 368.247 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 368.247 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 368.247 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 368.247 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 368.247 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 368.247 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 368.247 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 385.779 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 385.779 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 385.779 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 385.779 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 385.779 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 385.779 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 385.779 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 385.779 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 403.287 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 403.287 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 403.287 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 403.287 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 403.287 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 403.287 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 403.287 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 403.287 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 419.462 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 419.462 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 419.462 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 419.462 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 419.462 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 419.462 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 419.462 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 419.462 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 436.978 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 436.978 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 436.978 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 436.978 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 436.978 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 436.978 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 436.978 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 436.978 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 454.505 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 454.505 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 454.505 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 454.505 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 454.505 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 454.505 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 454.505 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 454.505 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 472.013 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 472.013 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 472.013 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 472.013 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 472.013 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 472.013 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 472.013 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 472.013 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 489.517 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 489.517 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 489.517 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 489.517 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 489.517 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 489.517 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 489.517 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 489.517 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 507.029 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 507.029 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 507.029 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 507.029 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 507.029 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 507.029 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 507.029 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 507.029 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 524.556 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 524.556 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 524.556 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 524.556 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 524.556 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 524.556 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 524.556 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 524.556 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 542.064 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 542.064 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 542.064 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 542.064 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 542.064 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 542.064 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 542.064 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 542.064 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 558.244 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 558.244 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 558.244 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 558.244 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 558.244 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 558.244 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 558.244 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 558.244 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 575.763 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 575.763 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 575.763 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 575.763 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 575.763 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 575.763 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 575.763 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 575.763 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 593.283 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 593.283 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 593.283 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 593.283 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 593.283 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 593.283 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 593.283 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 593.283 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 610.794 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 610.794 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 610.794 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 610.794 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 610.794 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 610.794 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 610.794 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 610.794 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 628.298 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 628.298 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 628.298 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 628.298 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 628.298 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 628.298 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 628.298 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 628.298 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 645.81 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 645.81 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 645.81 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 645.81 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 645.81 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 645.81 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 645.81 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 645.81 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 663.337 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 663.337 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 663.337 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 663.337 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 663.337 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 663.337 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 663.337 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 663.337 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 680.845 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 680.845 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 680.845 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 680.845 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 680.845 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 680.845 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 680.845 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 680.845 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 697.013 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 697.013 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 697.013 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 697.013 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 697.013 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 697.013 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 697.013 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 697.013 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 714.533 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 714.533 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 714.533 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 714.533 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 714.533 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 714.533 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 714.533 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 714.533 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 732.052 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 732.052 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 732.052 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 732.052 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 732.052 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 732.052 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 732.052 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 732.052 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 749.572 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 749.572 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 749.572 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 749.572 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 749.572 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 749.572 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 749.572 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 749.572 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 767.076 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 767.076 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 767.076 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 767.076 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 767.076 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 767.076 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 767.076 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 767.076 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 784.58 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 784.58 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 784.58 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 784.58 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 784.58 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 784.58 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 784.58 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 784.58 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 802.115 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 802.115 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 802.115 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 802.115 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 802.115 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 802.115 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 802.115 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 802.115 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 819.615 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 819.615 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 819.615 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 819.615 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 819.615 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 819.615 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 819.615 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 819.615 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 835.783 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 835.783 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 835.783 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 835.783 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 835.783 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 835.783 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 835.783 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 835.783 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 853.302 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 853.302 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 853.302 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 853.302 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 853.302 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 853.302 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 853.302 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 853.302 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 870.822 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 870.822 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 870.822 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 870.822 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 870.822 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 870.822 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 870.822 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 870.822 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 888.337 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 888.337 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 888.337 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 888.337 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 888.337 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 888.337 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 888.337 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 888.337 510.191)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 396.35,
    r: 3.12751,
    transform: "rotate(90 905.841 396.35)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 428.876,
    r: 3.12751,
    transform: "rotate(90 905.841 428.876)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 461.402,
    r: 3.12751,
    transform: "rotate(90 905.841 461.402)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 493.93,
    r: 3.12751,
    transform: "rotate(90 905.841 493.93)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 412.615,
    r: 3.12751,
    transform: "rotate(90 905.841 412.615)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 445.141,
    r: 3.12751,
    transform: "rotate(90 905.841 445.141)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 477.665,
    r: 3.12751,
    transform: "rotate(90 905.841 477.665)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 510.191,
    r: 3.12751,
    transform: "rotate(90 905.841 510.191)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 3.1303 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 3.1303 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 3.1303 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 3.1303 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 3.1303 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 3.1303 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 3.1303 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.1303,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 3.1303 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 20.6498 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 20.6498 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 20.6498 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 20.6498 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 20.6498 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 20.6498 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 20.6498 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20.6498,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 20.6498 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 38.1694 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 38.1694 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 38.1694 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 38.1694 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 38.1694 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 38.1694 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 38.1694 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 38.1694,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 38.1694 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 55.6889 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 55.6889 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 55.6889 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 55.6889 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 55.6889 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 55.6889 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 55.6889 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.6889,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 55.6889 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 73.1928 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 73.1928 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 73.1928 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 73.1928 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 73.1928 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 73.1928 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 73.1928 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 73.1928,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 73.1928 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 90.6967 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 90.6967 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 90.6967 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 90.6967 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 90.6967 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 90.6967 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 90.6967 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 90.6967,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 90.6967 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 108.232 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 108.232 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 108.232 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 108.232 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 108.232 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 108.232 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 108.232 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108.232,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 108.232 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 125.732 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 125.732 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 125.732 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 125.732 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 125.732 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 125.732 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 125.732 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125.732,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 125.732 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 141.9 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 141.9 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 141.9 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 141.9 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 141.9 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 141.9 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 141.9 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 141.9,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 141.9 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 159.419 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 159.419 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 159.419 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 159.419 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 159.419 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 159.419 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 159.419 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 159.419,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 159.419 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 176.939 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 176.939 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 176.939 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 176.939 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 176.939 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 176.939 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 176.939 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 176.939,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 176.939 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 194.455 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 194.455 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 194.455 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 194.455 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 194.455 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 194.455 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 194.455 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 194.455,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 194.455 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 211.958 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 211.958 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 211.958 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 211.958 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 211.958 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 211.958 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 211.958 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 211.958,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 211.958 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 229.474 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 229.474 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 229.474 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 229.474 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 229.474 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 229.474 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 229.474 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 229.474,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 229.474 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 247.001 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 247.001 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 247.001 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 247.001 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 247.001 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 247.001 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 247.001 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.001,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 247.001 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 264.501 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 264.501 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 264.501 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 264.501 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 264.501 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 264.501 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 264.501 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.501,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 264.501 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 280.677 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 280.677 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 280.677 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 280.677 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 280.677 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 280.677 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 280.677 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 280.677,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 280.677 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 298.197 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 298.197 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 298.197 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 298.197 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 298.197 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 298.197 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 298.197 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 298.197,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 298.197 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 315.716 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 315.716 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 315.716 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 315.716 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 315.716 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 315.716 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 315.716 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 315.716,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 315.716 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 333.232 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 333.232 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 333.232 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 333.232 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 333.232 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 333.232 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 333.232 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333.232,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 333.232 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 350.736 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 350.736 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 350.736 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 350.736 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 350.736 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 350.736 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 350.736 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 350.736,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 350.736 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 368.247 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 368.247 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 368.247 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 368.247 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 368.247 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 368.247 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 368.247 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 368.247,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 368.247 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 385.779 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 385.779 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 385.779 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 385.779 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 385.779 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 385.779 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 385.779 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 385.779,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 385.779 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 403.287 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 403.287 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 592.172,
    r: 3.12751,
    transform: "rotate(90 403.287 592.172)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 403.287 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 403.287 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 403.287 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 403.287 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 403.287,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 403.287 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 419.462 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 419.462 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 419.462 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 419.462 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 419.462 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 419.462 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 419.462 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.462,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 419.462 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 436.978 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 436.978 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 436.978 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 436.978 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 436.978 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 436.978 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 436.978 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 436.978,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 436.978 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 454.505 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 454.505 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 454.505 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 454.505 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 454.505 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 454.505 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 454.505 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.505,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 454.505 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 472.013 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 472.013 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 472.013 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 472.013 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 472.013 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 472.013 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 472.013 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 472.013,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 472.013 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 489.517 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 489.517 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 489.517 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 489.517 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 489.517 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 489.517 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 489.517 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 489.517,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 489.517 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 507.029 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 507.029 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 507.029 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 507.029 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 507.029 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 507.029 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 507.029 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 507.029,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 507.029 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 524.556 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 524.556 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 524.556 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 524.556 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 524.556 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 524.556 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 524.556 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 524.556,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 524.556 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 542.064 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 542.064 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 542.064 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 542.064 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 542.064 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 542.064 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 542.064 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 542.064,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 542.064 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 558.244 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 558.244 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 558.244 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 558.244 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 558.244 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 558.244 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 558.244 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.244,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 558.244 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 575.763 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 575.763 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 575.763 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 575.763 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 575.763 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 575.763 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 575.763 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 575.763,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 575.763 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 593.283 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 593.283 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 593.283 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 593.283 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 593.283 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 593.283 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 593.283 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 593.283,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 593.283 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 610.794 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 610.794 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 610.794 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 610.794 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 610.794 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 610.794 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 610.794 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 610.794,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 610.794 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 628.298 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 628.298 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 628.298 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 628.298 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 628.298 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 628.298 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 628.298 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 628.298,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 628.298 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 645.81 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 645.81 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 645.81 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 645.81 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 645.81 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 645.81 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 645.81 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 645.81,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 645.81 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 663.337 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 663.337 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 663.337 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 663.337 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 663.337 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 663.337 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 663.337 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 663.337,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 663.337 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 680.845 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 680.845 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 680.845 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 680.845 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 680.845 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 680.845 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 680.845 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 680.845,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 680.845 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 697.013 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 697.013 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 697.013 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 697.013 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 697.013 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 697.013 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 697.013 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 697.013,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 697.013 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 714.533 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 714.533 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 714.533 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 714.533 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 714.533 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 714.533 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 714.533 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 714.533,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 714.533 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 732.052 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 732.052 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 732.052 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 732.052 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 732.052 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 732.052 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 732.052 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 732.052,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 732.052 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 749.572 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 749.572 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 749.572 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 749.572 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 749.572 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 749.572 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 749.572 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 749.572,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 749.572 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 767.076 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 767.076 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 767.076 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 767.076 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 767.076 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 767.076 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 767.076 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 767.076,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 767.076 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 784.58 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 784.58 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 784.58 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 784.58 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 784.58 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 784.58 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 784.58 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 784.58,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 784.58 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 802.115 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 802.115 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 802.115 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 802.115 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 802.115 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 802.115 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 802.115 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 802.115,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 802.115 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 819.615 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 819.615 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 819.615 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 819.615 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 819.615 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 819.615 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 608.435,
    r: 3.12751,
    transform: "rotate(90 819.615 608.435)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 819.615,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 819.615 640.961)",
    fill: "#014514"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 835.783 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 835.783 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 835.783 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 835.783 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 835.783 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 835.783 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 835.783 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 835.783,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 835.783 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 853.302 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 853.302 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 853.302 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 853.302 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 853.302 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 853.302 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 853.302 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 853.302,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 853.302 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 870.822 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 870.822 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 870.822 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 870.822 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 870.822 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 870.822 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 870.822 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 870.822,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 870.822 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 888.337 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 888.337 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 888.337 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 888.337 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 888.337 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 888.337 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 888.337 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 888.337,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 888.337 640.961)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 527.121,
    r: 3.12751,
    transform: "rotate(90 905.841 527.121)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 559.647,
    r: 3.12751,
    transform: "rotate(90 905.841 559.647)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 592.173,
    r: 3.12751,
    transform: "rotate(90 905.841 592.173)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 624.701,
    r: 3.12751,
    transform: "rotate(90 905.841 624.701)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 543.386,
    r: 3.12751,
    transform: "rotate(90 905.841 543.386)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 575.912,
    r: 3.12751,
    transform: "rotate(90 905.841 575.912)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 608.436,
    r: 3.12751,
    transform: "rotate(90 905.841 608.436)",
    fill: "#014514"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 905.841,
    cy: 640.961,
    r: 3.12751,
    transform: "rotate(90 905.841 640.961)",
    fill: "#014514"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_528_48652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 914.252,
    height: 645,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_528_48652"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1379.76,
    height: 1030.15,
    fill: "white",
    transform: "translate(0 0.911467)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotGreen);
export default __webpack_public_path__ + "static/media/DotGreen.5a8a5bd932dbb725bb3056c713379e76.svg";
export { ForwardRef as ReactComponent };